import { render, staticRenderFns } from "./TrainDetail.vue?vue&type=template&id=0fbabc1c&scoped=true&"
import script from "./TrainDetail.vue?vue&type=script&lang=js&"
export * from "./TrainDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./TrainDetail.vue?vue&type=style&index=1&id=0fbabc1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbabc1c",
  null
  
)

export default component.exports